import { render, staticRenderFns } from "./viewlist.vue?vue&type=template&id=3aa3dfde&"
import script from "./viewlist.vue?vue&type=script&lang=js&"
export * from "./viewlist.vue?vue&type=script&lang=js&"
import style0 from "./viewlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports